import { BuzzkuriBreadcrumb } from '@components/buzzkuri/shared/uiParts/breadcrumb/BuzzkuriBreadcrumb'
import { ImageWraper } from '@components/shared/wraper/ImageWraper'
import { cloudfrontPath } from '@utils/image'
import Link from 'next/link'
import React from 'react'
import styles from './TeamBuilding.module.css'

export const TeamBuilding = (): JSX.Element => (
  <main className="mt-[84px] md:mt-[106px] lg:mt-[136px] leading-[2]">
    <div className="py-[10px] pl-[20px] lg:pl-[5%] bg-[#f7f7f7] lg:bg-white">
      <BuzzkuriBreadcrumb />
    </div>
    <div className={styles['team-building-w']}>
      <div className={styles['team-building-w--title']}>
        What is “team building” ?
      </div>
      <h1 className={styles['team-building-w--sub-title']}>
        チームビルディングとは
      </h1>
      <div className={styles['team-building-w--kv']}>
        <div className="hidden lg:block">
          <ImageWraper
            objectFit="contain"
            src={`${cloudfrontPath}/images/team-building/kv@2x.png`}
            width={1920}
            height={587}
          />
        </div>
        <div className="block lg:hidden">
          <ImageWraper
            objectFit="contain"
            src={`${cloudfrontPath}/images/team-building/sp/kv@2x.png`}
            width={640}
            height={444}
          />
        </div>
      </div>
      <div className={styles['team-building-w--message']}>
        <h2 className={styles['team-building-w--message--main']}>
          <span>チームビルディングとは、</span>
          <span>
            <span className={styles['strong']}>
              複数のメンバーが同じ一つのゴールを目指し、
            </span>
          </span>
          <span>
            <span className={styles['strong']}>
              チーム一丸となって進んでいけるような組織を作り上げていく
            </span>
          </span>
          <span>取り組みのことです。</span>
        </h2>
        <div className={styles['team-building-w--message--sub']}>
          <span>
            ビジネスの複雑化やIT化による企業を取り巻く環境が大きく変化するなか、組織の成果を最大化するための方法として
          </span>
          <span>多くの企業が注目し、導入を進めています。</span>
        </div>
      </div>
      <div className={styles['team-building-w--evidence']}>
        <div className={styles['team-building-w--evidence--h']}>
          <h3 className={styles['team-building-w--evidence--h--c']}>
            <span>チームビルディングは、</span>
            <span>生産性や成果向上に貢献</span>
          </h3>
          <div className={styles['team-building-w--evidence--h--d']}>
            <span>
              チームビルディングが進むとメンバー同士の信頼関係が深まるため、互いに協力し合い、また切磋琢磨しながらゴール
            </span>
            <span>達成に向けて考えて行動するようになります。</span>
            <br />
            <span>
              これにより、メンバーそれぞれのモチベーションが向上し、意欲的に仕事に取り組むようになるため、パフォーマンス
            </span>
            <span>が高まって 効率的な行動や生産性向上にも繋がります。</span>
          </div>
        </div>
        <div className={styles['team-building-w--evidence--d']}>
          <div className={styles['team-building-w--evidence--d--q']}>
            <div className="inline-block mr-[7px] w-[20px] h-[20px] align-middle">
              <ImageWraper
                src={`${cloudfrontPath}/images/team-building/question.svg`}
                width={20}
                height={20}
              />
            </div>
            <span>
              社員間の交流は生産性や成果の向上に影響すると思いますか？
            </span>
          </div>
          <div className={styles['team-building-w--evidence--d--g-pie']}>
            <div className="hidden lg:block">
              <ImageWraper
                src={`${cloudfrontPath}/images/team-building/pie_chart@2x.png`}
                width={1700}
                height={720}
              />
            </div>
            <div className="block lg:hidden">
              <ImageWraper
                src={`${cloudfrontPath}/images/team-building/sp/pie_chart@2x.png`}
                width={640}
                height={382}
              />
            </div>
          </div>
        </div>
      </div>
      <div className={styles['team-building-w--evidence']}>
        <div className={styles['team-building-w--evidence--h']}>
          <h3 className={styles['team-building-w--evidence--h--c']}>
            <span>チームビルディングが未熟だと、</span>
            <span>パフォーマンスを発揮しずらい</span>
          </h3>
          <div className={styles['team-building-w--evidence--h--d']}>
            <span>
              チームでの相互理解や信頼関係構築が達成されないと、個々人が持つパフォーマンスが発揮されにくくなります。
            </span>
            <br />
            <span>
              結果として、チームや組織全体としてのパフォーマンスも低下し、成果を最大化することができません。
            </span>
            <br />
            <span>
              チームビルディングは目標達成において非常に重要な役割を果たすと言えます。
            </span>
          </div>
        </div>
        <div className={styles['team-building-w--evidence--d']}>
          <div className={styles['team-building-w--evidence--d--q']}>
            <div className="inline-block mr-[7px] w-[20px] h-[20px] align-middle">
              <ImageWraper
                src={`${cloudfrontPath}/images/team-building/question.svg`}
                width={20}
                height={20}
              />
            </div>
            <span>
              上司や組織が求める適切なパフォーマンスを発揮できていると思うか
            </span>
          </div>
          <div
            className={styles['team-building-w--evidence--d--g-performance']}
          >
            <div className="hidden lg:block">
              <ImageWraper
                src={`${cloudfrontPath}/images/team-building/performance_chart@2x.png`}
                width={1700}
                height={720}
              />
            </div>
            <div className="block lg:hidden">
              <ImageWraper
                src={`${cloudfrontPath}/images/team-building/sp/performance_chart@2x.png`}
                width={640}
                height={898}
              />
            </div>
          </div>
        </div>
      </div>
      <div className={styles['team-building-w--evidence']}>
        <div className={styles['team-building-w--evidence--h']}>
          <h3 className={styles['team-building-w--evidence--h--c']}>
            チームビルディングのプロセス
          </h3>
          <div className={styles['team-building-w--evidence--h--d']}>
            <span>
              チームビルディングのプロセスは5段階に分類できます。形成期、混乱期、統一期、機能期、そして散会期です。
            </span>
            <br />
            <span>
              それぞれのフェーズにおいて、適切な手法を用いてチームビルディングを進めていく必要があります。
            </span>
            <br />
            <span>
              特に初期フェーズである「形成期」においては、
              <Link href="/programs/%E3%83%81%E3%83%BC%E3%83%A0%E3%83%93%E3%83%AB%E3%83%87%E3%82%A3%E3%83%B3%E3%82%B0">
                <a className="text-[#e6553a] underline">
                  研修やゲーム、ワークショップなど
                </a>
              </Link>
              を通じてコミュニケーションを深め、メンバーの性格や能力などの理解を進めていく必要があります。
            </span>
          </div>
        </div>
        <div className={styles['team-building-w--evidence--d-fades']}>
          <div>
            <div className="hidden lg:block">
              <ImageWraper
                src={`${cloudfrontPath}/images/team-building/fades@2x.png`}
                width={1700}
                height={480}
              />
            </div>
            <div className="block lg:hidden">
              <ImageWraper
                src={`${cloudfrontPath}/images/team-building/sp/fades@2x.png`}
                width={640}
                height={1337}
              />
            </div>
          </div>
        </div>
      </div>
      <div className={styles['team-building-w--evidence']}>
        <div className={styles['team-building-w--evidence--h']}>
          <h3 className={styles['team-building-w--evidence--h--c']}>
            <span>チームビルディングは</span>
            <span>特に形成期が重要</span>
          </h3>
          <div className={styles['team-building-w--evidence--h--d']}>
            <span>
              チームが作られたばかりの段階である形成期は、チームビルディングの土台となるため特に重要なフェーズと言えます。
            </span>
            <br />
            <span>
              この時点ではメンバーはお互いの性格や能力などの理解が不十分で、緊張感が漂っているので、それぞれバラバラの方向を向いています。
            </span>
            <br />
            <span>
              この時期にしっかりチームメンバーでコミュニケーションをとり、相互理解を深め、信頼関係を構築することで、混乱期でのチームの崩壊を防ぎ、統一期や機能期にスムーズに移行することができます。
            </span>
            <br />
            <span>
              <Link href="/programs/%E3%83%81%E3%83%BC%E3%83%A0%E3%83%93%E3%83%AB%E3%83%87%E3%82%A3%E3%83%B3%E3%82%B0">
                <a className="text-[#e6553a] underline">
                  プロジェクトに必要なスキルの研修や、少人数で行うゲームやワークショップ
                </a>
              </Link>
              を通じて相互理解と信頼関係を深めるチームビルディングが向いています。
            </span>
          </div>
        </div>
      </div>
    </div>
    <div className={styles['team-building-w--why']}>
      <div className={styles['team-building-w--why--box']}>
        <div className={styles['team-building-w--why--box--c']}>
          <span>初期のチームビルディングなら</span>
          <span>バヅクリ</span>
        </div>
        <div className={styles['team-building-w--why--box--d']}>
          <span>
            バヅクリはオンラインで社員同士の関係構築ができるチームビルディングサービスです。
          </span>
          <span>
            <Link href="/programs/%E3%83%81%E3%83%BC%E3%83%A0%E3%83%93%E3%83%AB%E3%83%87%E3%82%A3%E3%83%B3%E3%82%B0">
              <a className="text-[#e6553a] underline">
                チームビルディングに必要な“社員同士のつながり“、”オフコミュニケーション“を、アソビを通じたワークショップ
              </a>
            </Link>
            で創り出し、モチベーションとエンゲージメント、そして組織パフォーマンスを向上させることができます。
          </span>
          <span>
            オンラインとアソビの強みを活かして場所と立場の制約を超えることで、遠隔地にいる人たちとも体験を通じて仲良くなるので、リアルな飲み会や社内イベントよりも短時間で深い相互理解を実現します。
          </span>
        </div>
      </div>
      <div className={styles['team-building-w--why--detail']}>
        <Link href="/about">
          <a>バヅクリについてくわしく見る</a>
        </Link>
      </div>
    </div>
  </main>
)
